const { createHigherOrderComponent } = wp.compose;
const { InspectorControls, HeightControl } = wp.blockEditor;
const {
	PanelBody,
	TextControl,
	__experimentalToggleGroupControl: ToggleGroupControl,
	__experimentalToggleGroupControlOption: ToggleGroupControlOption,
	Tip

} = wp.components;
const { __ } = wp.i18n;

const { Fragment } = wp.element;
import classnames from 'classnames';
const blockList = [ 'core/image', 'core/post-featured-image' ];



/**
 * Function to register image styles for a block.
 *
 * @param {Object} settings - The settings object for the block.
 * @param {string} name - The block name.
 * @return {Object} - The modified settings object with image styles registered.
 */
const imageStylesRegister = ( settings, name ) => {

	// Do nothing if it's another block than our defined ones.
	if ( !blockList.includes( name ) ) {

		return settings;

	}

	settings.attributes = Object.assign( settings.attributes, {
		roundedCorners: {
			type: 'string',
		},
		customAspectRatio: {
			type: 'string',
		},
		customFixedHeight: {
			type: 'string',
		}
	} );

	return settings;

};

wp.hooks.addFilter(
	'blocks.registerBlockType',
	'core/image/register/custom/style',
	imageStylesRegister
);

const imageCoreEdit = createHigherOrderComponent( ( BlockEdit ) => {

	return ( props ) => {

		if ( blockList.includes( props.name ) ) {

			const { attributes, setAttributes } = props;
			const { roundedCorners, customAspectRatio, customFixedHeight } = attributes

			const roundedCornersControl = (

				<InspectorControls group={'styles'}>
					<PanelBody title="Corner radius" initialOpen={true}>
						<ToggleGroupControl
							value={roundedCorners}
							isBlock
							__nextHasNoMarginBottom
							onChange={( value ) => setAttributes( { roundedCorners: value } )}
						>
							<ToggleGroupControlOption value="0" label="0"/>
							<ToggleGroupControlOption value="20" label="20px"/>
							<ToggleGroupControlOption value="35" label="35px"/>
						</ToggleGroupControl>
					</PanelBody>
				</InspectorControls>

			)
			const customSettingsControl = (

				<InspectorControls group={'settings'}>
					<PanelBody title={__( 'Extra settings', 'wombat' )}>
						<TextControl
							label={'Custom aspect ratio'}
							__nextHasNoMarginBottom
							help={__( 'Set the aspect ratio above to \'original\'. Separate the proportions with a / symbol.', 'wombat' )}
							onChange={( value ) => setAttributes( { customAspectRatio: value } )}
							value={customAspectRatio}
						/>
						<HeightControl
							label={'Fixed height'}
							onChange={( value ) => setAttributes( { customFixedHeight: value } )}
							value={customFixedHeight}
						/>
						{customFixedHeight && (
							<Tip>
								{__( 'Fixed height has been set. Please leave the Custom Aspect Ratio field empty.', 'wombat' )}
							</Tip>
						)}

					</PanelBody>
				</InspectorControls>
			)

			return (
				<Fragment>
					{roundedCornersControl}
					<BlockEdit {...props} />
					{customSettingsControl}
				</Fragment>
			);

		}
		return <BlockEdit {...props} />;

	};

}, 'withInspectorControl' )

wp.hooks.addFilter(
	'editor.BlockEdit',
	'wombat/with-inspector-controls',
	imageCoreEdit
);

/**
 * Add custom class to block in Edit
 *
 * @param {string} BlockListBlock
 * @param {string} imageStyleList
 *
 * @return {object}
 */
const imageStylesList = createHigherOrderComponent( ( BlockListBlock ) => {

	return ( props ) => {

		// If current block is not allowed
		if ( !blockList.includes( props.name ) ) {

			return (
				<BlockListBlock {...props} />
			);

		}

		const { className, attributes } = props;
		const { roundedCorners, customAspectRatio, customFixedHeight } = attributes

		const extraClasses = classnames(
			className, {
				[ `has-${roundedCorners}-radius` ]: roundedCorners,
				[ `has-custom-ratio` ]: customAspectRatio !== undefined && customAspectRatio !== '',
				[ `has-fixed-height` ]: customFixedHeight !== undefined && customFixedHeight !== '',
			}
		)
		const wrapperProps = {
			...props.wrapperProps,
			'style': {
				...attributes.customAspectRatio ? { '--custom-aspect-ratio': attributes.customAspectRatio } : {},
				...attributes.customFixedHeight ? { '--custom-fixed-height': attributes.customFixedHeight } : {},
			},
			'className': extraClasses
		};

		return <BlockListBlock
			{...props} wrapperProps={wrapperProps}
		/>

	};

}, 'imageStyleList' );

wp.hooks.addFilter(
	'editor.BlockListBlock',
	'core/image/list/custom/style/',
	imageStylesList
);

/**
 * Applies image styles to the saved element props if block type is "core/image".
 *
 * @param {Object} saveElementProps - The properties of the saved element.
 * @param {Object} blockType - The block type object.
 * @param {Object} attributes - The attributes of the block.
 * @return {Object} - The modified saveElementProps.
 */
const imageStylesSave = ( saveElementProps, blockType, attributes ) => {

	if ( !blockList.includes( blockType.name ) ) {

		return saveElementProps;

	}
	const { roundedCorners, customAspectRatio, customFixedHeight } = attributes

	if ( roundedCorners !== undefined && roundedCorners !== '' ) {

		saveElementProps.className = classnames(
			saveElementProps.className, {
				[ `has-${roundedCorners}-radius` ]: roundedCorners,
			}
		);

	}
	if ( customAspectRatio !== undefined && customAspectRatio ) {

		if ( !saveElementProps.style ) {

			saveElementProps.style = {};

		}
		saveElementProps.style[ '--custom-aspect-ratio' ] = customAspectRatio;
		saveElementProps.className = classnames(
			saveElementProps.className, {
				[ `has-custom-ratio` ]: customAspectRatio,
			}
		);

	}
	if ( customFixedHeight !== undefined && customFixedHeight ) {

		if ( !saveElementProps.style ) {

			saveElementProps.style = {};

		}
		saveElementProps.style[ '--custom-fixed-height' ] = customFixedHeight;
		saveElementProps.className = classnames(
			saveElementProps.className, {
				[ `has-fixed-height` ]: customFixedHeight,
			}
		);

	}


	return saveElementProps;

};

wp.hooks.addFilter(
	'blocks.getSaveContent.extraProps',
	'core/image/save/custom/style',
	imageStylesSave
);
